import React from 'react';
import StoreList from '../components/stores/StoreList';

const StoresPage: React.FC = () => {
  return (
    <div className="p-4 md:p-8">
      <div className="max-w-7xl mx-auto">
        <div className="mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Store Management</h1>
          <p className="mt-2 text-gray-600">
            Manage your connected Shopify stores and their configurations.
          </p>
        </div>

        <div className="bg-white rounded-lg shadow p-6">
          <StoreList />
        </div>
      </div>
    </div>
  );
};

export default StoresPage;